export const Bio = {
    name: "Ronitkumar Sabhaya",
    roles: [
      "Aspiring Software Developer",
    ],
    description:
      "I am an aspiring software developer. I am a passionate and self-motivated individual, who is eager to learn new technologies and apply them to real-world problems. I am a quick learner and a team player who is always ready to take on new challenges.",
    github: "https://github.com/Ronitsabhaya75",
    // resume:
    //   "https://drive.google.com/file/d/1wViRno0NU6wvvLDk-RHsMHR51VC8b2EK/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/ronitkumarsabhaya75/",
  };
  
  
  export const experiences = [
    {
      id: 1,
      img: "https://yt3.googleusercontent.com/ytc/AIdro_kdvnp9_bcICNr-t6-rBJtqim70NdI9p24X_6SAvaki6exo=s900-c-k-c0x00ffffff-no-rj",
      role: "Software Engineer Intern",
      company: "Trading Technologies",
      date: "June 2025 - Aug 2025",
      desc: "• Reduced manual PR review time by 30% by implementing Python path mapping algorithms within a Yaml file to detect missing test files by cross-referencing file-path metadata.\n• Designed an automated notification system that accelerated failure detection by 39% to intercept test failures and stream real-time diagnostic reports to Slack.\n• Improved testing efficiency by 35% by architecting AWS Launch Templates to initialize EC2 instances for high-performance, self-hosted test execution.\n• Optimized image-building process by replacing manual S3 workflows with an automated fetch and build system by utilizing Podman and Kubernetes to accelerate the deployment of containers by 33%.",
    }, 

    {
      id: 0,
      img: "https://yt3.googleusercontent.com/ytc/AIdro_nMQquL6P1xbvss6cVa225hcQNTEm1x8zeBHImJ9V_jG0o=s900-c-k-c0x00ffffff-no-rj",
      role: "Research Assistant",
      company: "University of North Texas",
      date: "March 2025 - Present",
      desc: "Reviewing and analyzing Research papers on voice biometrics, spoof detection, and signal processing techniques.Assisting a master's student on research focused on AI-based voice liveness detection to determine whether a sound input is real or fake.",
    },

    {
      id: 2,
      img: "https://upload.wikimedia.org/wikipedia/en/2/29/University_of_Texas_at_Arlington_seal.svg",
      role: "Computer Science Tutor",
      company: "University of Texas at Arlington",
      date: "Aug 2024 - Dec 2024",
      desc: "Mentored 30+ students, assisting students in mastering subject material and solving complex programming problems. Facilitated 10 hours of weekly one-on-one tutoring sessions, teaching students and enhancing my understanding of problem-solving strategies.Collaborated with Student Success Center representatives in weekly meetings to discuss strategies for improving student outcomes and enhancing tutoring services.",
    },
    {
      id: 3,
      img: "https://itlab.uta.edu/logo/itlab_logo.jpg",
      role: "Research Assistant",
      company: "IT Lab, University of Texas at Arlington",
      date: "May 2024 - Dec 2024",
      desc: "Optimized user interaction and interface functionality by 50% for a Multi-Layer Network Dashboard (MLN) using React and Flask. Developed data visualization scripts with Matplotlib and Plotly, integrating timestamp checks to reduce regeneration time by 30%. Implemented pattern detection efficiency by 75% through comprehensive analysis of MLN data, leading to improvement in accuracy.",
    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://yt3.googleusercontent.com/ytc/AIdro_nMQquL6P1xbvss6cVa225hcQNTEm1x8zeBHImJ9V_jG0o=s900-c-k-c0x00ffffff-no-rj",
      school: "University of North Texas",
      date: "Jan 2025 - Present",
      grade: "3.80/4.00",
      degree: "Bachelor of Science - Computer Science",
    },
    {
      id: 1,
      img: "https://upload.wikimedia.org/wikipedia/commons/d/da/UTA_logomark.png",
      school: "University of Texas - Arlington",
      date: "June 2023 - Dec 2024",
      grade: "3.50/4.00",
      degree: "Bachelor of Science - Computer Science",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "AWS CDK",
      tags: ["Typescript", "Cloud infra", "Infrastructure as code", "AWS", "Shell", "Alloy", "Docker"],
      webapp: "https://aws.amazon.com/cdk/",
      github: "https://github.com/aws/aws-cdk",
    },
    {
      id: 1,
      title: "Apple FoundationDB",
      tags: ["C", "C++", "Java", "Python", "Go", "Cmake"],
      webapp: "https://apple.github.io/foundationdb/",
      github: "https://github.com/apple/foundationdb",
    },
    {
      id: 2,
      title: "AutoBoard",
      tags: [
        "React", "AWS Lambda", "AWS S3", "Gemini", "AWS RDS", "FastAPI", "AWS VPC",
      ],
      webapp: "https://github.com/Rabib001/HackUTD_2025",
      github: "https://github.com/Rabib001/HackUTD_2025",
    },
    {
      id: 3,
      title: "Lux-UI",
      tags: [
        "Swift", "iOS", "macOS", "SwiftUI", "Github Actions"
      ],
      webapp: "https://luxeui.vercel.app/",
      github: "https://github.com/Ronitsabhaya75/Luxe-UI",
    },
    {
      id: 5,
      title: "Apple Containers",
      tags: ["Swift", "Github Actions", "Containers", "Linux", "macOS"],
      webapp: "https://opensource.apple.com/projects/container/",
      github: "https://github.com/apple/container",
    },
    {
      id: 4,
      title: "Apple Swift System metrics",
      tags: ["SwiftUI", "Instruments", "Promoethus", "Grafana", "Linux", "macOS", "Darwin", "iOS", "watchOS", "tvOS"],
        webapp: "https://swiftpackageindex.com/apple/swift-system-metrics/1.2.1/documentation/systemmetrics",
      github: "https://github.com/apple/swift-system-metrics",
    },


  ];
  
